const CollabData = [
    { img: "/Images/philanthropy2.png" },
    { img: "/Images/Benchmark logo.jpeg" },
    { img: "/Images/philanthropy1.png" },
    { img: "/Images/Frappe-logo.jpg" },
    { img: "/Images/techsoup-global-logo-vector-3746621461.png" },
]


export { CollabData }